import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceVehicleForm from './ServiceVehicleForm'

import { updateServiceVehicle } from '../services'
import { handleError } from '../../../helpers'

export default function EditServiceVehicleModal({ visible, onClose, serviceVehicle, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({ 
		defaultValues: { 
			minutes_planned: serviceVehicle.minutes_planned,
			minutes_used: serviceVehicle.minutes_used,
			kilometers_used: serviceVehicle.kilometers_used,
		}
	})

	const onSubmit = values => {
		setLoading(true)
		updateServiceVehicle(serviceVehicle.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ServiceVehicleForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}